// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function () {
	// <script id="mcjs">!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/461e9d1969dbbe0e889cef186/02ecf0135f6ab59bb60dbb8b9.js");</script></head> 

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});